import React, { useEffect, useState, useContext, ChangeEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";

import Dropdown from 'react-bootstrap/Dropdown';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import './Notifications.scss';
import useUtils from '../../../utiles/useUtiles';
import { UserDetailsI } from '../../../utiles/interfaces'

import { NOTIFICATION_CATEGORY } from '../../../utiles/constants';
import { SocketContext } from '../../../utiles/context/socket-context';

const Notifications: React.FC = () => {

	const { user, axiosRequest, baseUrl, handleError } = useUtils();
	const userDetails: UserDetailsI | null = user();
	const axiosInstance = axiosRequest();
	const navigate = useNavigate();
	const socket = useContext(SocketContext);

	const [ pagination, setPagination ] = useState<any>({
		page: 0,
		pageSize: 5
	})
	const [notifications, setNotifications] = useState<any>({
        rows: [],
        totalUnread: 0
    })

	const receiveMsg = ( message: any ) => {
		console.log('message: ', message)
		if ( message && message['category'] && message['category'] == NOTIFICATION_CATEGORY.REQUEST_FOR_TEMPLATE ) {
			setNotifications((prevState: any) => ({
				rows: [ message, ...prevState['rows'] ],
				totalUnread: prevState['totalUnread'] + 1
			}))
		}
	}

	useEffect(() => {
		// Your Socket.IO code goes here
		socket.on('notifications', receiveMsg);

		getNotification();
	}, []);

	useEffect(() => {
		if ( pagination.page > 0 ) {
			getNotification();
		}
	}, [ pagination.page ])

	const handleClick = ( row: any, index: number ) => {
		if ( row['has_read'] !== 1 ) {
			readNotifications( row, index );
		}
		if ( row['category'] == NOTIFICATION_CATEGORY.REQUEST_FOR_TEMPLATE ) {
			navigate("/csv-tool/requested-templates");
		}
		if ( row['category'] == NOTIFICATION_CATEGORY.IBV_VERIFICATION_FAILED ) {
			navigate("/ibv-account-verification");
		}
	}

	const readNotifications = async ( row: any, index: number ) => {
		try {
			const param = {
				id: row['id']
			};
			
            const request = await axiosInstance.put( `${baseUrl()}/notifications`, param );
            const { error, msg, data } = request.data;
            if ( error ) throw msg;
			var rows = JSON.parse(JSON.stringify(notifications['rows']))
			rows.splice(index, 1, { ...row, has_read: 1});
            setNotifications({
				rows: rows,
				totalUnread: data
			})
        } catch ( e: any ) {
            handleError( e );
        }
	}

	async function getNotification() {
        try {
			const queryString = `role_id=${userDetails?.role}&page=${pagination['page']}&pageSize=${pagination['pageSize']}`;
            const request = await axiosInstance.get( `${baseUrl()}/notifications?${queryString}` );
            const { error, msg, result } = request.data;
            if ( error ) throw msg;
            setNotifications((prevState: any) => ({
				rows: [ ...prevState['rows'], ...result['rows'] ],
				totalUnread: result['totalUnread']
			}))
        } catch ( e: any ) {
            handleError( e );
        }
    }

	const handleScroll: React.UIEventHandler<HTMLDivElement> = ( event ) => {
		const target = event.target as HTMLDivElement;
		if ( target.scrollTop + target.clientHeight >= (target.scrollHeight - 1) ) {
			setPagination((prevState: any) => ({
				...prevState,
				page: prevState.page + 1
			}))
		}
	};

	return (
		<>
			<Dropdown className='notification-dropdown'>
				<Dropdown.Toggle variant="default" id="dropdown-basic">
					<span color="secondary">
						<Badge badgeContent={notifications.totalUnread} color="success">
							<NotificationsNoneIcon color="action" />
						</Badge>
					</span>
				</Dropdown.Toggle>

				{
					notifications.rows.length && 
					<Dropdown.Menu>
						<div className='drop-item-wrapper' onScroll={handleScroll}>
							{
								notifications.rows.map((row: any, index: number) => (
									<Dropdown.Item key={index} onClick={() => handleClick(row, index)} style={ row['has_read'] !== 1 ? { backgroundColor: 'cornsilk' } : {}}>
										<div>
											<h5>{row['subject']}</h5>
											<p>{format(new Date(row['createdAt']), "MM/dd/yyyy hh:mm a")}</p>
											<p>{row['message']}</p>
										</div>
									</Dropdown.Item>
								))
							}
						</div>
					</Dropdown.Menu> || <></>
				}
				
			</Dropdown>
		</>
	);
}

export default Notifications;
